
import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import CampaignAddress from "../address";
import ReactInputMask from "react-input-mask";

const NewCampaignCompany = () => {
    const navigate = useNavigate();
    // const [rowId, setRowID] = useState({ text: "", error: false, textError: "" });
    const [name, setName] = useState({ text: "", error: false, textError: "" });
    const [phone, setPhone] = useState({ text: "", error: false, textError: "" });
    const [email, setEmail] = useState({ text: "", error: false, textError: "" });
    const [url, setUrl] = useState({ text: "", error: false, textError: "" });
    const [category, setCatgeory] = useState({ text: "", error: false, textError: "" });
    const [addresses, setAddresses] = useState({})

    const submitHandler = async (e) => {
        e.preventDefault();

        // const formattedCompany = company.map((element) => element.attributes);
        const data = {
            // external_row_id: rowId.text,
            company_name: name.text,
            company_phone: phone.text,
            company_email: email.text,
            company_url: url.text,
            company_category: category.text,
            ...addresses
        };
        try {
            await CrudService.createCampaignCompany(data);
            navigate("/campaign/company", {
                state: { value: true, text: "The company was successfully created" },
            });
        } catch (err) {
            if (err.hasOwnProperty("msg")) {
                setName({ ...name, error: true, textError: err.msg });
            }
            console.error(err);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Add New Campaign Company
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox component="form" method="POST" onSubmit={submitHandler}>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    {/* <FormField
                                        type="text"
                                        label="External Row ID"
                                        name="external_row_id"
                                        value={rowId.text}
                                        error={rowId.error}
                                        onChange={(e) => setRowID({ ...rowId, text: e.target.value })}
                                    />
                                    {rowId.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {rowId.textError}
                                        </MDTypography>
                                    )} */}
                                    <FormField
                                        required
                                        type="text"
                                        label="Company Name"
                                        name="name"
                                        value={name.text}
                                        error={name.error}
                                        onChange={(e) => setName({ ...name, text: e.target.value })}
                                    />
                                    {name.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {name.textError}
                                        </MDTypography>
                                    )}
                                    <ReactInputMask
                                        mask="(999) 999-9999"
                                        value={phone.text}
                                        onChange={(e) => setPhone({ ...phone, text: e.target.value })}
                                    >
                                        {() => (
                                            <FormField
                                                label="Company Phone"
                                                placeholder="(123) 456-7890"
                                            />
                                        )}
                                    </ReactInputMask>
                                    <FormField
                                        type="text"
                                        label="Company Email"
                                        name="email"
                                        value={email.text}
                                        error={email.error}
                                        onChange={(e) => setEmail({ ...email, text: e.target.value })}
                                    />
                                    {email.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {email.textError}
                                        </MDTypography>
                                    )}
                                    <FormField
                                        type="text"
                                        label="Company Url"
                                        name="url"
                                        value={url.text}
                                        error={url.error}
                                        onChange={(e) => setUrl({ ...url, text: e.target.value })}
                                    />
                                    {url.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {url.textError}
                                        </MDTypography>
                                    )}
                                    <FormField
                                        type="text"
                                        label="Company Category"
                                        name="catgeory"
                                        value={category.text}
                                        error={category.error}
                                        onChange={(e) => setCatgeory({ ...category, text: e.target.value })}
                                    />
                                    {category.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {category.textError}
                                        </MDTypography>
                                    )}

                                    <CampaignAddress addresses={addresses} setAddresses={setAddresses} />

                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/campaign/company", {
                                                        state: { value: false, text: "" },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit">
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default NewCampaignCompany;
